<main class="c-main">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12"></div>
            <!-- ngFor for para percorrer o array de erros e se existir erros imprimir na tela -->
            <div class="alert alert-danger" role="alert" *ngFor="let erro of mensagemErros">
                {{ erro }}
            </div>
        </div>
        <div class="mat-elevation-z8">    
            <mat-card>    
                <mat-card-title>
                    <mat-icon>color_lens</mat-icon>
                    Movimentação
                </mat-card-title>
                <mat-tab-group mat-align-tabs="start" #tabGroup>
                    <mat-tab>
                        <ng-template mat-tab-label>
                            <mat-icon>add</mat-icon>
                            Movimentação
                        </ng-template>
                        <!-- CADASATRANDO OBJETO INICIO -->
                        <mat-card>
                            <form [formGroup]="formulario" (ngSubmit)="submit()">
                                <div class="row">
                                    <div class="col-1">
                                        <mat-form-field class="full-width" appearance="fill" style="width: 100%;">
                                            <mat-label>ID</mat-label>
                                            <input formControlName="id" matInput readonly>
                                        </mat-form-field>
                                    </div>                                      
                                    <div class="col-3">                     
                                        <mat-form-field appearance="fill" style="width: 100%;">
                                            <mat-label>Conta Origem</mat-label>
                                            <mat-select id="caixaOrigen" name="caixaOrigen" [(value)]="caixaOrigen">
                                                <mat-option [value]="box.id" *ngFor="let box of boxsAtivo">{{box.name}}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>                                                           
                                </div>
                                <div class="col-3">                     
                                    <mat-form-field appearance="fill" style="width: 100%;">
                                        <mat-label>Conta Destino</mat-label>
                                        <mat-select id="caixaDestino" name="caixaDestino" [(value)]="caixaDestino">
                                            <mat-option [value]="''"></mat-option>
                                            <mat-option [value]="box.id" *ngFor="let box of boxsAtivo">{{box.name}}</mat-option>
                                        </mat-select>
                                    </mat-form-field>                                                           
                                </div>
                                    <div class="col-2">
                                        <mat-form-field class="full-width" appearance="fill" style="width: 100%;">
                                            <mat-label>Valor Movimentação</mat-label>
                                            <span matPrefix>R$ &nbsp;</span>                                           
                                            <input matInput formControlName="valorMovimentacao"
                                                currencyMask  [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }" required>                                             
                                        </mat-form-field>
                                    </div>                                    
                                    <div class="col-3"  *ngIf="caixaDestino === ''">
                                        <mat-form-field class="full-width" appearance="fill" style="width: 100%;">
                                            <mat-label>Tipo de Movimentação</mat-label>
                                            <mat-select formControlName="tipoMovimentacao">
                                                <mat-option value="ENTRADA">Entrada</mat-option>
                                                <mat-option value="SAIDA">Saida</mat-option>
                                            </mat-select>                                            
                                        </mat-form-field>
                                    </div>
                                    <div class="col-12">
                                        <mat-form-field class="full-width" appearance="fill" style="width: 100%;">
                                            <mat-label>Observacao</mat-label>
                                            <textarea formControlName="observacao" matInput placeholder="Observacao"></textarea>
                                        </mat-form-field>                             
                                    </div>
                                </div>

                                <div class="row justify-content-between">
                                    <div class="col-6">
                                        <!-- habilita desabilita botão com o forma validate -->
                                        <button (click)="limparFormulario()" mat-raised-button>
                                            <mat-icon>insert_drive_file</mat-icon>
                                            Limpar
                                        </button>
                                    </div>
                                    <div class="col-6" align="right">
                                        <!-- habilita desabilita botão com o forma validate -->
                                        <button [disabled]="!formulario.valid" mat-raised-button color="primary">
                                            <mat-icon>save</mat-icon>
                                            Salvar
                                        </button>
                                    </div>
                                </div>
                            </form>
                            <div class="esp-top">
                                <!-- verifica se tem erros no preenchimento do campo e se inicio o preenchimento -->
                                <div *ngIf="formulario.controls.observacao.errors && !formulario.controls.observacao.pristine"
                                    class="alert alert-warning" role="alert">
                                    Campo nome deve conter entre 3 e 50 caracteres!
                                </div>
                        
                            </div>
                        </mat-card>
                    </mat-tab>
                    <!-- CADASATRANDO OBJETO INICIO -->

                    <!-- LISTANDO TODAS INICIO -->
                    <mat-tab>
                        <ng-template mat-tab-label>
                            <mat-icon>list</mat-icon>
                            Listar Movimentações
                        </ng-template>
                        <mat-card>
                            <!-- //inicio da tabela --> 
                            <div class="row"> 
                                <div class="col-4">                    
                                        <mat-form-field appearance="fill" style="width: 100%;">
                                            <mat-label>Consulta Por</mat-label>
                                            <mat-select id="tipoFiltro" name="tipoFiltro" [(value)]="tipoFiltro" required>
                                                <mat-option [value]="tipoFiltro" *ngFor="let tipoFiltro of tipoFiltros">{{tipoFiltro}}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                </div>
                                <div class="col-6" *ngIf="tipoFiltro == 'Periodo'" style="display: flex;">
                                    <div class="col-6">
                                        <mat-form-field class="full-width" appearance="fill" style="width: 100%;">
                                            <mat-label>Inicio</mat-label>
                                            <input id="dataInicio" matInput [matDatepicker]="dataInicio" name="dataInicio" mask="00/00/0000" style="width: 80%;">                                
                                                <mat-datepicker-toggle matIconSuffix [for]="dataInicio" style="position: absolute;top: -13px;">
                                                </mat-datepicker-toggle>
                                                <mat-datepicker #dataInicio></mat-datepicker>
                                        </mat-form-field>
                                    </div>
                                    <div class="col-6">
                                        <mat-form-field class="full-width" appearance="fill" style="width: 100%;">
                                            <mat-label>Fim</mat-label>
                                            <input id="dataFim" matInput [matDatepicker]="dataFim" name="dataFim" mask="00/00/0000" style="width: 80%;">                                
                                                <mat-datepicker-toggle matIconSuffix [for]="dataFim" style="position: absolute;top: -13px;">
                                                </mat-datepicker-toggle>
                                                <mat-datepicker #dataFim></mat-datepicker>
                                        </mat-form-field>
                                    </div>
                                </div>
                                <div class="col-6" *ngIf="tipoFiltro == 'Pagamento'">
                                    <mat-form-field class="full-width" appearance="fill" style="width: 100%;">
                                        <mat-label>Telefone</mat-label>
                                        <input [(ngModel)]="parametroConsulta" name="parametroConsulta" mask="(00) 0 0000-0000 || (00) 0000-0000" matInput>
                                    </mat-form-field>
                                </div>  
                                <div class="col-2">
                                            <button (click)="consultar()" mat-raised-button color="primary" style="line-height: 51px;width: 100%;">
                                                <mat-icon>search</mat-icon>
                                                Consultar
                                            </button>                                        
                                </div>
        
                        </div>                                                
                                        <table mat-table [dataSource]="movimentacoes" class="full-width">
                                            <!-- Coluna ID -->
                                            <ng-container matColumnDef="id">
                                                <th mat-header-cell *matHeaderCellDef> ID </th>
                                                <td mat-cell *matCellDef="let movimentacao"> {{ movimentacao.id }} </td>
                                            </ng-container>

                                            <!-- Coluna Nome -->
                                            <ng-container matColumnDef="contaOrigemDescricao">
                                                <th mat-header-cell *matHeaderCellDef> Caixa Origem </th>
                                                <td mat-cell *matCellDef="let movimentacao"> {{ movimentacao.contaOrigemDescricao  }} </td>
                                            </ng-container>
                                        
                                            <ng-container matColumnDef="contaDestinoDescricao">
                                                <th mat-header-cell *matHeaderCellDef> Caixa Destino </th>
                                                <td mat-cell *matCellDef="let movimentacao"> {{ movimentacao.contaDestinoDescricao  }} </td>
                                            </ng-container>

                                            <ng-container matColumnDef="valorMovimentacao">
                                                <th mat-header-cell *matHeaderCellDef> Valor Movimentação</th>
                                                <td mat-cell *matCellDef="let movimentacao"> {{ movimentacao.valorMovimentacao | currency:'BRL' }} </td>
                                            </ng-container>

                                            <ng-container matColumnDef="tipoMovimentacao">
                                                <th mat-header-cell *matHeaderCellDef> Tipo </th>
                                                <td mat-cell *matCellDef="let movimentacao"> {{ movimentacao.tipoMovimentacao  }} </td>
                                            </ng-container>                                                                                   
                                            <!-- definir como vai ser as linhas e a ordem das colunas -->
                                            <tr mat-header-row *matHeaderRowDef="ordemColunasTabela"></tr>
                                            <tr mat-row *matRowDef="let row; columns: ordemColunasTabela;"></tr>
                                        </table>

                                        <!-- paginação -->
                                        <mat-paginator [length]="totalElementos" [pageSize]="tamanho"
                                        [pageSizeOptions]="pageSizeOptions" (page)="paginar($event)">
                                        <!-- evento de paginar -->
                                            </mat-paginator>
                                </mat-card>
                         </mat-tab>
               <!-- LISTANDO TODAS FIM -->
           </mat-tab-group>
       </mat-card>
   </div>
</div>

</main>